import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { startAddEntry } from '../../actions';
import EntryForm from './EntryForm';

export class AddEntryPage extends Component {

  onFormActionSubmit = (entry) => {
    this.props.startAddEntry(entry);
    // this.props.history.push('/cashier');
  };

  render() {
    return (
      <div>
        <Typography variant="display1" gutterBottom>
          Add Entry
        </Typography>
        <EntryForm
          editMode={false}
          onFormActionSubmit={this.onFormActionSubmit}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
    startAddEntry: (entry) => dispatch(startAddEntry(entry))
});

export default connect(undefined, mapDispatchToProps)(AddEntryPage);



// WEBPACK FOOTER //
// ./src/components/entries/AddEntryPage.js